export var Dictionary = Object;
